import { render, staticRenderFns } from "./softwareVideo.vue?vue&type=template&id=77f00b20&scoped=true&"
import script from "./softwareVideo.vue?vue&type=script&lang=js&"
export * from "./softwareVideo.vue?vue&type=script&lang=js&"
import style0 from "./softwareVideo.vue?vue&type=style&index=0&id=77f00b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f00b20",
  null
  
)

export default component.exports